import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
/**
 * S-138: UI v2 の opt-in スコープ。
 *
 * `UiV2Scope` の中では Button / Input / Select / Textarea / TextField / Modal が既定で v2
 *（枠線なし・文字 7 段・面の色差 / docs/UI-GUIDE.md）になる。外（v1 の app）では既定どおり v1。
 * 各 primitive の `v2` prop で個別に上書きできる（`v2={false}` で v1 に戻す）。
 * 書体・字間・行間（`.ui-v2` / ui-v2.css）も同じ要素に当てるので、app の layout route を
 * これで包むだけで S-132 段階 1 と S-138 の両方が効く。
 */
const UiV2Context = createContext(false);
export function useUiV2(override) {
    const scoped = useContext(UiV2Context);
    return override ?? scoped;
}
export function UiV2Scope({ children, className, as: Tag = 'div' }) {
    return (_jsx(UiV2Context.Provider, { value: true, children: _jsx(Tag, { className: className ? `ui-v2 ${className}` : 'ui-v2', children: children }) }));
}
/** DOM を増やさず context だけ与える（既に `.ui-v2` を当てた要素の内側で使う）。 */
export function UiV2Provider({ children, value = true }) {
    return _jsx(UiV2Context.Provider, { value: value, children: children });
}
//# sourceMappingURL=v2.js.map